import React, { useState } from 'react';
import { handleFileUpload } from '../../../services/uploadFiles';
import { Loader } from 'lucide-react';
import Spacing from '../../Spacing';

export default function OnboardPracticeUploadFiles() {
  const [formData, setFormData] = useState({ practice_name: '' });
  const [locations, setLocations] = useState([{ name: '' }]);
  const [patientFile, setPatientFile] = useState(null);
  const [icdFile, setIcdFile] = useState(null);
  const [cptFile, setCptFile] = useState(null);
  const [selectedEMR, setSelectedEMR] = useState('');
  const [loading, setLoading] = useState(false);

  const renderFileInput = (label, fileState, setFileState, id) => (
    <div className="docpro_grid_item">
      <label className="docpro_fw_500 docpro_primary_color">{label} <span className="docpro_red_color">*</span></label>
      <div className='input_file_conatiner mt-1'>
        <label htmlFor={id} className='file_button'>Choose File</label>
        <input
          type="file"
          id={id}
          required
          className='file_hidden_input'
          accept=".xls,.xlsx"
          onChange={(e) => setFileState(e.target.files[0])}
        />
        <span className='file_label'>{fileState ? fileState.name : 'No file chosen'}</span>
      </div>
    </div>
  );

  const isFormValid =
    formData.practice_name.trim() !== '' &&
    locations[0].name.trim() !== '' &&
    selectedEMR !== '' &&
    patientFile &&
    icdFile &&
    cptFile;

  return (
    <div className="docpro_card">
      <h2 className="docpro_page_heading docpro_fs_24 mb-4">Onboarding File Upload</h2>
      <form onSubmit={(e) => handleFileUpload(e, {
          practice_name: formData.practice_name,
          location_name: locations[0].name,
          emr: selectedEMR,
          patient_file: patientFile,
          icd_file: icdFile,
          cpt_file: cptFile,
        }, setLoading)}
      >
        <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
          <div className="docpro_grid_item">
            <label className="docpro_fw_500 docpro_primary_color">Practice Name <span className="docpro_red_color">*</span></label>
            <input
              type="text"
              required
              value={formData.practice_name}
              onChange={(e) => setFormData({ ...formData, practice_name: e.target.value })}
              className="docpro_form_field size_lg"
            />
          </div>

          <div className="docpro_grid_item">
            <label className="docpro_fw_500 docpro_primary_color">Location Name </label>
            <input
              type="text"
              // required
              value={locations[0].name}
              onChange={(e) => {
                const newLocations = [...locations];
                newLocations[0].name = e.target.value;
                setLocations(newLocations);
              }}
              className="docpro_form_field size_lg"
            />
          </div>

          <div className="docpro_grid_item">
            <label className="docpro_fw_500 docpro_primary_color">Format Type <span className="docpro_red_color">*</span></label>
            <select
              className="docpro_form_field size_lg"
              required
              value={selectedEMR}
              onChange={(e) => setSelectedEMR(e.target.value)}
            >
              <option value="" disabled>Select EMR</option>
              <option value="MDLand">MDLand</option>
              {/* <option value="ECW">ECW</option> */}
            </select>
          </div>

          {renderFileInput('Patient File', patientFile, setPatientFile, 'file-upload-patient')}
          {renderFileInput('ICD File', icdFile, setIcdFile, 'file-upload-icd')}
          {renderFileInput('CPT File', cptFile, setCptFile, 'file-upload-cpt')}
        </div>

        <Spacing lg="30" sm="30" />

        <div className="flex justify-end mt-6">
          <button
            type="submit"
            className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg flex items-center"
            disabled={loading || !isFormValid}
          >
            {loading && <span className="docpro_loading mr-2"><Loader width={20} height={20} /></span>}
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
